import { AnimationRightToLeft, KhAnimationProps } from '@internal-libraries/kheops-ui-lib'

export const DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT: Partial<KhAnimationProps> = {
    text: '',
    animation: AnimationRightToLeft.DEFAULT_ANIMATION,
    margin: 35,
    verticalAlign: true,
    containerWidth: undefined,
}
